import firebase from "firebase/app";
import "firebase/auth";

export const config = firebase.initializeApp({
  apiKey: "AIzaSyC8A64s-sWLIp_F6n7MSn94igXeizkbguA",
  authDomain: "rgac-register.firebaseapp.com",
  projectId: "rgac-register",
  storageBucket: "rgac-register.appspot.com",
  messagingSenderId: "341429155397",
  appId: "1:341429155397:web:389319eaa903d119b3d52c",
  measurementId: "G-XJ111S01WL"
});
